import { createReducer, on } from '@ngrx/store'
import { UserContextActions } from './action-types'
export const initState: IUserContextState = {
    user: {},
    project: {},
    projects: [],
    // seznam klicu projektu, ke kterym ma uzivatel opravneni, po jeho zmene dojde k prenacteni projektu z backendu
    projectKeys: []
}

export const userContextReducer = createReducer(
    initState,
    on(UserContextActions.userContextReset, () => {
        return {...initState}
    }),
    on(UserContextActions.userContextSetProjects, (state, props) => {
        return {...state, projects: props.projects}
    }),
    on(UserContextActions.userContextSetUser, (state, props) => {
        return {...state, user: props.user}
    }),
    on(UserContextActions.userContextSetProjectKeys, (state, props) => {
        return {...state, projectKeys: props.keys}
    }),
    on(UserContextActions.userContextSetProject, (state, props) => {
        return {...state, project: props.project}
    })
)

export interface IUserContextState {
    user: any;
    projects: any[];
    project: any;
    projectKeys: string[];
}